import client from './api-client';

export const getCargasPrevias = async(query) => {
    try {
        
        const response = await client.get(`conciliacion/historial-cargas?q=${query}`);
       
        if (response.status === 200 && response.data.code === 1) {
            return {
                cargas_previas: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getIngresoPagos = async(query) => {
    try {
        
        const response = await client.get(`conciliacion/pagos-xls?q=${query}`);
       
        if (response.status === 200 && response.data.code === 1) {
            return {
                ingresoPagos: response.data
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}


export const postCargarArchivo = async(file) => {
    try {
        
        const response = await client.post('conciliacion/carga-archivo', file);
      
        if (response.status === 200 && response.data.code === 1) {
            return response.data.message;
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}